import axios, {
  defaultRequestHandler,
  getToken,
  params as buildParams,
} from 'services/API/common/Fetcher';
import { ContentType } from 'services/API/common/Headers';
import {
  IPWhitelistMutationRequest,
  IPWhitelistMutationResponse,
  IPWhitelistPaginatedResponse,
} from './interface';

const basePath = (companyId: string) => `/companies/${companyId}/ip-whitelist/mp`;

export const listIPWhitelist = (
  companyId: string,
  params: Record<string, unknown> = {},
): Promise<IPWhitelistPaginatedResponse> =>
  defaultRequestHandler(
    axios.get(`${basePath(companyId)}?${buildParams(params)}`, {
      headers: {
        authorization: getToken(),
      },
    }),
  );

export const upsertIPWhitelist = (
  companyId: string,
  payload: IPWhitelistMutationRequest,
): Promise<IPWhitelistMutationResponse> =>
  defaultRequestHandler(
    axios.post(basePath(companyId), payload, {
      headers: {
        authorization: getToken(),
        'Content-Type': ContentType.json,
      },
    }),
  );

export const removeIPWhitelist = (
  companyId: string,
  whitelistId: string,
): Promise<IPWhitelistMutationResponse> =>
  defaultRequestHandler(
    axios.delete(`${basePath(companyId)}/${whitelistId}`, {
      headers: {
        authorization: getToken(),
      },
    }),
  );
